// extracted by mini-css-extract-plugin
export default {"container":"FirstAccess_container__urZqH","stepsContainer":"FirstAccess_stepsContainer__184+0","cardFirstAccess":"FirstAccess_cardFirstAccess__DPdG6"};